import { Table } from '../../Table';
import useTable from '../../../hooks/useTable';
import { TableComponentProps } from '../types';

const columnLables = {
  liquidity_0_to_1_day: {
    name: 'Percentage of portfolio liquidity in 0 to 1 day',
    order: 178
  },
  liquidity_2_to_7_days: {
    name: 'Percentage of portfolio liquidity in 2 to 7 days',
    order: 179
  },
  liquidity_8_to_30_days: {
    name: 'Percentage of portfolio liquidity in 8 to 30 days',
    order: 180
  },
  liquidity_31_to_90_days: {
    name: 'Percentage of portfolio liquidity in 31 to 90 days',
    order: 181
  },
  liquidity_91_to_180_days: {
    name: 'Percentage of portfolio liquidity in 91 to 180 days',
    order: 182
  },
  liquidity_181_to_365_days: {
    name: 'Percentage of portfolio liquidity in 181 to 365 days',
    order: 183
  },
  liquidity_over_365_days: {
    name: 'Percentage of portfolio liquidity in more than 365 days',
    order: 184
  },
  unencumbered_cash: {
    name: 'Unencumbered cash amount',
    order: 185
  }
};

export function LiquidityProfiles({
  onChangeFund,
  funds,
  currentDataKey,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) {
  const {
    rows: rows,
    columns: columns,
    onChange: onChange
  } = useTable({
    data: funds[currentDataKey]?.fund_data?.PORTFOLIO_LIQUIDITY_PROFILE,
    onChangeFund,
    schema: schema.PORTFOLIO_LIQUIDITY_PROFILE,
    isStaticTemplate,
    requiredFields:
      funds[currentDataKey]?.required_tables?.PORTFOLIO_LIQUIDITY_PROFILE?.field_names || [],
    isSingleData: true,
    isMultiFunds,
    funds,
    tableName: 'PORTFOLIO_LIQUIDITY_PROFILE',
    columnLables
  });

  return (
    <Table
      id="reporttables-liquidity-profiles-table"
      handleChanges={onChange}
      columns={columns}
      rows={rows}
      stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 2 : null}
      stickyTopRows={isMultiFunds ? 1 : null}
    />
  );
}
